<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">投诉详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉人" prop="name">
                <el-input
                  v-model="data.name"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-input
                  v-model="data.phone"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉来源" prop="platform">
                <el-select
                  v-model="data.platform"
                  placeholder="请选择"
                  :disabled="true"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintSourceArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉对象" prop="becomplained">
                <el-input
                  v-model="data.becomplained"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉时间" prop="createdate">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.createdate"
                  v-bind:disabled="true"
                  format="yyyy-MM-dd HH:mm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="事发地" prop="address">
                <el-input
                  v-model="data.address"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉状态" prop="status">
                <el-select
                  v-model="data.status"
                  :disabled="true"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintStatusArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理类型" prop="type">
                <el-radio-group
                  v-model="data.type"
                  :disabled="true"
                >
                  <el-radio :label="1">投诉</el-radio>
                  <el-radio :label="2">建议</el-radio>
                  <el-radio :label="3">反馈</el-radio>
                  <el-radio :label="0">其他</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉内容" prop="content">
                <el-input
                  v-model="data.content"
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉图片" prop="productimages">
                <el-image v-for="(ele,index) in productimagesArr"
                  :key="index"
                  style="width:100px;height:130px;padding-right:10px;"
                  :src="ele"
                  :preview-src-list="getPreviewImgList(index)"
                ></el-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉语音" prop="voice">
                <div v-for="(ele,index) in productvoicesArr" :key="index">
                  <audio v-bind:src="ele.pathurl" controls="controls"></audio>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉视频" prop="video">
                <div v-for="(ele,index) in productvideosArr" :key="index">
                  <video controls style="width:300px;height:150px;margin-bottom:10px;">
                    <source v-bind:src="ele" type="video/mp4" />
                  </video>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否受理" prop="isaccept">
                <el-radio-group
                  v-model="data.isaccept"
                  :disabled="!IsEdit||(data.status!='0')"
                >
                  <el-radio :label="1">受理</el-radio>
                  <el-radio :label="0">不予受理</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="24" v-if="data.isaccept=='1'">
              <el-form-item label="投诉类型" prop="resulttype">
                <el-radio-group
                  v-model="data.resulttype"
                  :disabled="!IsEdit||((data.status!=0)&&(data.status!=1))"
                >
                  <el-radio :label="item.code" :key="item.code" v-for="item in ComplaintSubTypeArr">{{item.value}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="data.isaccept=='0'">
              <el-form-item label="不受理原因" prop="noprocessingreason">
                <el-radio-group
                  v-model="data.noprocessingreason"
                  :disabled="!IsEdit||((data.status!=0)&&(data.status!=1))"
                >
                  <el-radio :label="item.code" :key="item.code" v-for="item in NoProcessReasonArr">{{item.value}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="!IsEdit||data.status!='0'||(data.status=='0'&&data.isaccept=='0')">
              <el-form-item label="结案说明" prop="processcontent">
                <el-input
                  v-model="data.processcontent"
                  :disabled="!IsEdit||((data.status!=0)&&(data.status!=1))"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row v-if="data.isheavy==1||data.status==4||data.status==5">
            <el-col :span="23" :offset="1">重诉详情<el-divider></el-divider></el-col
          ></el-row>

          <el-row style="margin-top: 20px" v-if="data.isheavy==1||data.status==4||data.status==5">
            <el-col :span="24">
              <el-form-item label="重诉理由" prop="heavyreasons">
                <el-input
                  v-model="data.heavyreasons"
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row v-if="data.isheavy==1||data.status==4||data.status==5">
            <el-col :span="12">
              <el-form-item label="是否重诉受理" prop="isacceptheavy">
                <el-radio-group
                  v-model="data.isacceptheavy"
                  :disabled="!IsEdit||(data.status!=4)"
                >
                  <el-radio :label="0">不予受理</el-radio>
                  <el-radio :label="1">受理</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="(data.isheavy==1&&!IsEdit)||(data.status==5&&data.isacceptheavy==1)||(data.status==4&&data.isacceptheavy==0)">
            <el-col :span="24">
              <el-form-item label="重诉完结说明" prop="heavythatend">
                <el-input
                  v-model="data.heavythatend"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import ZJApp from "../../../../../app";
import ComplaintApi from "../../../apis/src/ComplaintApi";
import axios from 'axios'

export default {
  name: "ComplaintAllDealInfo",
  controller: "UI",
  action: "ComplaintAllDealInfo",
  data() {
    return {
      data: {
        TouristFeedback: 0,
        ComplaintTime: new Date(),
      },
      ComplaintSourceArr: [
        { value: 1, label: "app安卓" },
        { value: 2, label: "appiOS" },
        { value: 3, label: "官网" },
        { value: 4, label: "公众号" },
        { value: 5, label: "小程序" },
        { value: 6, label: "其他" },
      ],
      ComplaintStatusArr: [
        { value: 0, label: "待受理" },
        { value: 1, label: "已受理" },
        { value: 2, label: "不予受理" },
        { value: 3, label: "处理完成" },
        { value: 4, label: "重诉待受理" },
        { value: 5, label: "重诉已受理" },
        { value: 6, label: "已完结" },
      ],
      ComplaintSubTypeArr: [
        { code: "1", value: "景区设施" },
        { code: "2", value: "服务设施" },
        { code: "3", value: "物价" },
      ],
      NoProcessReasonArr: [
        { code: "Fake", value: "虚假投诉" },
        { code: "can_not_reach", value: "无法联系" },
        { code: "Over_Time", value: "超时关闭" },
        { code: "re_call", value: "游客撤诉" },
        { code: "not_a_complaint", value: "非投诉" },
      ],
      loading: false,
      loadingText: "加载中...",
      IsEdit: false,
      uploadData: {
        module: "ComplaintManager", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
      rules: {
        TRASHCODE: [
          { required: true, message: "请输入垃圾桶编号", trigger: "blur" },
        ],
        TRASHNAME: [
          { required: true, message: "请输入垃圾桶名称", trigger: "blur" },
        ],
        LONGITUDE: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        LATITUDE: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        BELONGAREA: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        TRASHTYPE: [
          { required: true, message: "请选择垃圾桶类型", trigger: "change" },
        ],
      },
      productimagesArr:[],
      productvideosArr:[],
      productvoicesArr:[],
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid(),
    };
  },
  created: function() {
     if (this.$route.query.InfoId) {
        this.data = this.$route.query.Info;
      }
   
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    this.getComplaintType();
    this.getNoProcessReason();
    this.productimagesArr=(this.data.productimages==null||this.data.productimages=="")?[]:this.data.productimages.split(',');
    this.productvideosArr=(this.data.video==null||this.data.video=="")?[]:this.data.video.split(',');
    this.getVoicesArr(this.data.id);
    this.data.type=(this.data.type==0&&this.data.status==0)?1:this.data.type;
  },
  mounted: function() {
    
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
       // this.getFileList();
      }
    },
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    getVoicesArr(id){
      var formData=new URLSearchParams();
      formData.append('id',id);
      axios.post(global.$config.api.apiUrl+"/member-api/member/suggestDetail",formData)
     .then((res) => {
       this.productvoicesArr=res.data.data.voices;  
       })
     .catch((err) => {return err})
    },
    initVideo() {
      //原生初始化视频方法
      let myVideo = this.$refs.video;
      //ontimeupdate
        myVideo.ontimeupdate = function() {myFunction()};

        function myFunction(){
            let playTime = myVideo.currentTime
            setTimeout(function () {
                localStorage.setItem("cacheTime",playTime)
            },500)
            let time = localStorage.getItem("cacheTime")
            // 当前播放位置发生变化时触发。
            if(playTime - Number(time) > 2){
                myVideo.currentTime = Number(time)
            }
        }
    },
    beforeDestroy() {
            if (this.player) {
                this.player.dispose()
            }
        },
    getPreviewImgList: function(index){
      let arr=[];
      for(let i=0;i<this.productimagesArr.length;i++){
        arr.push(this.productimagesArr[i+index]);
        if(i+index>=this.productimagesArr.length-1){
          index=0-(i+1);
        }
      }
      return arr;
    },
    SourceToNameConverter(num) {
      const SourceName = this.ComplaintSourceArr.map((item) => {
        if (item.value == num) return item.label;
      }).join("");
      return SourceName;
    },
    getComplaintType(){
      var formData=new URLSearchParams();
      formData.append('groupCode',"ts_type");
      axios.post(global.$config.api.apiUrl+"/common-api/common/findSDictionaryByGroupCode",formData)
     .then((res) => {
       this.ComplaintSubTypeArr=res.data.data;  
       })
     .catch((err) => {return err})
    },
    getNoProcessReason(){
      var formData=new URLSearchParams();
      formData.append('groupCode',"ts_close_reason");
      axios.post(global.$config.api.apiUrl+"/common-api/common/findSDictionaryByGroupCode",formData)
     .then((res) => {
       this.NoProcessReasonArr=res.data.data;  
       })
     .catch((err) => {return err})
    },
    
    //获取上传附件
    getFileList() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        const searchInfo = { AssocID: InfoId, PageSize: 100, PageIndex: 1 };
        this.data = this.$route.query.Info;
        this.loading = true;
        new Apis.FileApi()
          .GetFileList(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.fileList = r.FileList.map((item) => ({
              name: item.FileName,
              url: item.DownloadPath + "?d=1",
            }));
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      if (this.$route.query.type == "edit") {
        //编辑
        //判断是否为空
        if(this.data.status==0&&this.data.isaccept==0){
          if(this.data.noprocessingreason==null||this.data.noprocessingreason==""){
            this.$message.error("请选择不受理原因！");
            this.loading =false;
            return;
          }
          if(this.data.processcontent==null||this.data.processcontent==""){
            this.$message.error("请填写结案说明！");
            this.loading =false;
            return;
          }
        }
        if(this.data.status==0&&this.data.isaccept==1){
          if(this.data.resulttype==null||this.data.resulttype==""){
            this.$message.error("请选择投诉类型！");
            this.loading =false;
            return;
          }
        }
        if(this.data.status==1&&this.data.isaccept==1){
          if(this.data.resulttype==null||this.data.resulttype==""){
            this.$message.error("请选择投诉类型！");
            this.loading =false;
            return;
          }
          if(this.data.processcontent==null||this.data.processcontent==""){
            this.$message.error("请填写结案说明！");
            this.loading =false;
            return;
          }
        }
        if(this.data.status==4&&this.data.isacceptheavy==0){
          if(this.data.heavythatend==null||this.data.heavythatend==""){
            this.$message.error("请填写重诉完结说明！");
            this.loading =false;
            return;
          }
        }
        if(this.data.status==5&&this.data.isacceptheavy==1){
          if(this.data.heavythatend==null||this.data.heavythatend==""){
            this.$message.error("请填写重诉完结说明！");
            this.loading =false;
            return;
          }
        }
        //转换状态
        var statusNow;
        if(this.data.status==0&&this.data.isaccept==1)//待受理-接受受理
          statusNow=1;//已受理
        else if(this.data.status==0&&this.data.isaccept==0)//待受理-不接受受理
          statusNow=6;//已完结
        else if(this.data.status==4&&this.data.isacceptheavy==1)//重诉待受理-接受受理
          statusNow=5;//重诉已受理
        else if(this.data.status==4&&this.data.isacceptheavy==0)//重诉待受理-不接受受理
          statusNow=6;//已完结
        else if(this.data.status==1)//已受理-完结
          statusNow=3;//处理完成
        else if(this.data.status==5)//重诉已受理-完结
          statusNow=6;//已完结
        else
          statusNow=0;
        let data={
          id:this.data.id,
          status:statusNow,
          processcontent:this.data.processcontent,
          type:1,
          resulttype:this.data.resulttype,
          noprocessingreason:this.data.noprocessingreason,
          isaccept:this.data.isaccept,
          isacceptheavy:this.data.isacceptheavy,
          heavythatend:this.data.heavythatend
        };
        let formAll = JSON.stringify(data);
        formAll = JSON.parse(formAll);
        ComplaintApi.SuggestUpdate(formAll)
          .then((r) => {
            r = r.msg;
            this.$message({
              type: "success",
              message: r =="成功"? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Id: this.uuid,
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    beforeupload: function() {
      this.uploadData.assocID = this.uuid;
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function() {
      this.loading = false;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    },
  },
};
</script>
